var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    [_vm.$style.footer]: true,
    [_vm.$style.footerFullWidth]: _vm.settings.isContentNoMaxWidth
  }},[_c('div',{class:_vm.$style.inner},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('p',{staticClass:"font-weight-bold"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" CCEAD S.A")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }